// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { currencyMenuStyles } from "@insite/content-library/Widgets/Common/CurrencyMenu";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

currencyMenuStyles.currencyWrapper = {
    css: css`
        display: flex;
        align-items: center;
        padding: 10px 0px;
    `,
};

currencyMenuStyles.currencySelect = {
    backgroundColor: "common.accent",
    iconProps: {
        css: css`
            &&& {
                max-width: 18px;
                max-height: 18px;
                padding: 0px;
                top: 7px;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: 70px;
        `,
        inputSelect: css`
            height: 30px;
            width: 70px;
            border: none;
            text-transform: uppercase;
            font-size: 12px;
        `,
    },
};

currencyMenuStyles.currencySymbol = {
    size: fontConfig.fontSize.small,
    css: css`
        color: ${getColor("primary.contrast")};
        white-space: nowrap;
        padding-right: 10px;
    `,
};
